/**
 * Event key names
 */
export enum KeyName {
    enter = 'Enter',
    esc = 'Escape',
    space = ' ',
    leftArrow = 'ArrowLeft',
    upArrow = 'ArrowUp',
    rightArrow = 'ArrowRight',
    downArrow = 'ArrowDown',
    tab = 'Tab',
    shift = 'Shift'
}
